import { render, staticRenderFns } from "./CrudBulkOrder.vue?vue&type=template&id=fbc81f3e&scoped=true&"
import script from "./CrudBulkOrder.vue?vue&type=script&lang=js&"
export * from "./CrudBulkOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc81f3e",
  null
  
)

export default component.exports